import { jsx as _jsx } from "react/jsx-runtime";
import { getAdvanceBookingPeriodForFilm, isFilmAvailableForBookings } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { FilmCategory } from '@vista-digital/ocapi-types/v1';
import { observer } from 'mobx-react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { ButtonSize } from '../../../subcomponents';
import { Button } from '../../../subcomponents/button/button';
const b = bemClassBuilder('v-member-film-watchlist-film-button');
export const MemberFilmWatchlistFilmButton = observer(props => {
    const i18n = useI18n();
    const { film, filmAvailability } = useFilmContext();
    const { onClick, displayText } = props;
    if (!film || !filmAvailability)
        return null;
    const status = getButtonStatusForFilm(filmAvailability);
    return (_jsx(Button, { className: b.block(), size: ButtonSize.Large, onClick: () => onClick(film), label: getLabelForStatus(displayText, film, status, i18n), disabled: status !== MemberFilmWatchlistFilmButtonStatus.BookNow }));
});
MemberFilmWatchlistFilmButton.displayName = 'MemberFilmWatchlistFilmButton';
var MemberFilmWatchlistFilmButtonStatus;
(function (MemberFilmWatchlistFilmButtonStatus) {
    MemberFilmWatchlistFilmButtonStatus["BookNow"] = "BookNow";
    MemberFilmWatchlistFilmButtonStatus["ComingSoon"] = "ComingSoon";
    MemberFilmWatchlistFilmButtonStatus["AdvanceBookingSoon"] = "AdvanceBookingSoon";
    MemberFilmWatchlistFilmButtonStatus["Unavailable"] = "Unavailable";
})(MemberFilmWatchlistFilmButtonStatus || (MemberFilmWatchlistFilmButtonStatus = {}));
const getButtonStatusForFilm = (filmAvailability) => {
    if (isFilmAvailableForBookings(filmAvailability.filmId))
        return MemberFilmWatchlistFilmButtonStatus.BookNow;
    if (filmAvailability.categories.includes(FilmCategory.AdvanceBooking)) {
        return MemberFilmWatchlistFilmButtonStatus.AdvanceBookingSoon;
    }
    if (filmAvailability.categories.includes(FilmCategory.ComingSoon)) {
        return MemberFilmWatchlistFilmButtonStatus.ComingSoon;
    }
    return MemberFilmWatchlistFilmButtonStatus.Unavailable;
};
const getLabelForStatus = (displayText, film, status, i18n) => {
    switch (status) {
        case MemberFilmWatchlistFilmButtonStatus.BookNow:
            return displayText.filmBookNowButtonLabel;
        case MemberFilmWatchlistFilmButtonStatus.AdvanceBookingSoon:
        case MemberFilmWatchlistFilmButtonStatus.ComingSoon: {
            const bookingPeriod = getAdvanceBookingPeriodForFilm(film.id);
            if (bookingPeriod) {
                return i18n.template(displayText.filmAdvanceBookingSoonButtonLabel, {
                    startsAt: bookingPeriod.startsAt
                });
            }
            return i18n.template(displayText.filmComingSoonButtonLabel, { releaseDate: film.releaseDate });
        }
        case MemberFilmWatchlistFilmButtonStatus.Unavailable:
            return displayText.filmUnavailableButtonLabel;
        default:
            throw new Error(`Cannot get label for unknown MemberFilmWatchlistFilmButtonStatus '${status}'.`);
    }
};
